import { createFeature, createReducer, on } from '@ngrx/store';
import { ReceiptModel } from '@shared/data-access/models';
import { ReceiptAction } from '../actions';

export const featureName = 'receipt';

export interface ReceiptState {
  item: ReceiptModel | null;
}
export const initialState: ReceiptState = {
  item: null,
};
export const receiptFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(ReceiptAction.loadItemSuccess, (state, prop: { item: ReceiptModel }) => ({ ...state, item: prop.item }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = receiptFeature;
